import React, { Fragment, h } from "preact";
import {Field} from 'react-final-form'
import RepeatMail from "./RepeatMail";
import {validateSameMail} from '../validateForms'
import {t} from "../../../_i18n";


export default ({input}) => <Field name='emails' component={RepeatMail} validate={validateSameMail} input={input}/>
